import { render, staticRenderFns } from "./ClientPeriodReports.vue?vue&type=template&id=00a9f564"
import script from "./ClientPeriodReports.vue?vue&type=script&lang=js"
export * from "./ClientPeriodReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports